import React, { Component } from 'react'
import { AssignmentsManage } from '../../components'
import * as assignmentsManageActionCreators from '../../redux/modules/assignmentsManage'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import sampleItems from './sampleItems'
import arrayify from '../../helpers/arrayify'
import disarrayify from '../../helpers/disarrayify'
import { db } from '../../config/firebaseconfig'
import timestamper from '../../helpers/timestamper'
import getAssignmentById from '../../helpers/getAssignmentById'

const uuid = require('uuid/v1')

// Disable Item Add when no assignment selected!

// Handle selecting an assignment to edit or create new, instead of defaulting to new. 

// Clear settings if not selected yet.

// Delete assignment

// Don't worry about item preview yet

// MAKE IT SO YOU CAN'T SAVE A NAME OR SETTINGS WHEN ASSIGNMENT IS NOT SELECTED

// MAYBE I SHOULD ONLY BE PUSHING AROUND ID'S INSTEAD OF ENTIRE OBJECTS. FIX THIS UP

// MAKE SO NOTHING HAPPENS WHEN YOU SELECT THE DUMMY OPTION IN THE SELECT BOX

class AssignmentsManageContainer extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      assignmentName: '',
      assignmentType: '',
      search: '',
      searchType: 'name',     // name, code, question, node
    }

    this.createNewAssignment = this.createNewAssignment.bind(this)
    this.addUnitToAssignmentAndSave = this.addUnitToAssignmentAndSave.bind(this)
    this.saveSettings = this.saveSettings.bind(this)
    this.handleAssignmentNameValueChange = this.handleAssignmentNameValueChange.bind(this)
    this.deleteUnitFromAssignmentAndSave = this.deleteUnitFromAssignmentAndSave.bind(this)
    this.selectAssignment = this.selectAssignment.bind(this)
    this.addAssignmentToUser = this.addAssignmentToUser.bind(this)
    this.removeAssignmentFromUser = this.removeAssignmentFromUser.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.deleteAssignment = this.deleteAssignment.bind(this)
    this.handleSearchChange = this.handleSearchChange.bind(this)
  }

  componentWillUnmount() {
    if (this.unsubscribeContentItems) {
      this.unsubscribeContentItems()
    }
    if (this.unsubscribeAssignments) {
      this.unsubscribeAssignments()
    }
    if (this.unsubscribeUsers) {
      this.unsubscribeUsers()
    }

  }

  componentDidMount() {
    // some fetching code and then eventually...
    // this.props.fetchingAssignmentsSuccess(/* assignments */)
/*

    var unsubscribeContentItems = db.collection('contentItems').onSnapshot(
      (docs) => {
        let output = []
        docs.forEach( (doc) => {
          output.push(doc.data())
        })
        this.props.fetchingSuccess(output)
      }, 
      (error) => this.props.fetchingError(error)

*/
    // get items
    // doing it this way might not be best. Might not want array but instead object?
    let items
    this.unsubscribeContentItems = db.collection('contentItems').onSnapshot(
      (docs) => {
        let output = []
        docs.forEach( (doc) => {
          output.push(doc.data())
        })
        items = output.map( (item) => {
          return {
            ...item,
            answers: arrayify(item.answers)
          }
        })
        this.props.fetchingItemsSuccess(items)
      },
      (error) => this.props.fetchingItemsError(error)
    )


    this.props.fetchingAssignments()
    this.unsubscribeAssignments = db.collection('assignments').onSnapshot(
      (docs) => {
        let assignmentsList = []
        docs.forEach((doc) => {
          const data = doc.data()
          const assignment = {
            ...data,
            units: arrayify(data.units),
          }
          if (!data.deleted) {
            assignmentsList.push(assignment)
          }
        })
        this.props.fetchingAssignmentsSuccess(assignmentsList)
      },
      (error) => this.props.fetchingAssignmentsError(error)
    )

// Need to eventually get these calls more specific and filtered or will crash

    this.props.fetchingUsers()
    this.unsubscribeUsers = db.collection('users').onSnapshot(
      (docs) => {
        let usersList = []
        docs.forEach((doc) => {
          const user = doc.data()
          usersList.push(user)
        })
        this.props.fetchingUsersSuccess(usersList)
      },
      (error) => this.props.fetchingUsersError(error)
    )

    this.props.fetchingNodes()
    db.collection('knowledgeMapNodes').get()
      .then((querySnapshot) => {
        let nodes = {}
        querySnapshot.forEach((doc) => {
          const data = doc.data()
          nodes[data.id] = data
        })
        this.props.fetchingNodesSuccess(nodes)
      })
      .catch((err) => this.props.fetchingNodesError(err))

    

//    let assignmentsList = []
//    this.props.fetchingAssignments()
/*    db.collection('assignments').get()
      .then( (querySnapshot) => {
        querySnapshot.forEach( (doc) => {
          const data = doc.data()
          const assignment = {
            ...data,
            units: arrayify(data.units)
          }
          assignmentsList.push(assignment)
        })
        this.props.fetchingAssignmentsSuccess(assignmentsList)
      })
      .catch( (error) => this.props.fetchingAssignmentsError(error) )
*/
  }

  deleteAssignment() {
    this.props.setSavingTrue()
    db.collection('assignments').doc(this.props.assignmentId).set({deleted: true},{merge: true})
      .then(() => {
        this.props.deletingSuccess()
        this.setState({
          assignmentName: '',
          assignmentType: '',
        })
      })
      .catch((error) => this.props.savingError(error))
  }

  handleChange(e) {
    let newState = {
      [e.target.name]: e.target.value,
    }
    this.setState(newState, () => this.props.noChanges ? this.props.setNoChangesFalse() : null)
  }

  handleSearchChange(e) {
    let newState = {
      [e.target.name]: e.target.value,
    }
    if (e.target.value === 'node') {
      newState.search = ''
    }
    this.setState(newState)
  }

  addUnitToAssignmentAndSave(assignmentUnit, timestamp) {
    this.props.addActiveAssignmentUnit({assignmentUnit, timestamp})
    const newUnitArray = this.props.assignment.units.concat(assignmentUnit).map( (unit) => {
      let answers
      Array.isArray(unit.answers) 
      ? answers = disarrayify(unit.answers, 'answer') 
      : answers = []
      return {
        ...unit,
        answers,
      }
    })
    const newUnitObj = disarrayify(newUnitArray, 'unit')
    this.props.setSavingTrue()
    db.collection('assignments').doc(this.props.assignmentId).update({
      units: newUnitObj
    })
      .then( () => this.props.savingSuccess() )
      .catch( (error) => this.props.savingError(error) )
  }

  deleteUnitFromAssignmentAndSave(index) {
    this.props.setSavingTrue()
    let assignmentUnits = this.props.assignment.units.slice(0)
    assignmentUnits.splice(index, 1)
    const timestamp = timestamper()
    this.props.setActiveAssignmentUnits({assignmentUnits, timestamp})
    const units = disarrayify(assignmentUnits, 'unit')
    db.collection('assignments').doc(this.props.assignmentId).update({
      units,
      lastModifiedDate: timestamp,
    })
      .then( () => this.props.savingSuccess() )
      .catch( (error) => this.props.savingError() )
  }

  createNewAssignment(e) {
    if (e) { 
      e.preventDefault() 
    }
    const id = uuid()
    const time = timestamper()
    const creator = 'Craig Gehring'
    this.props.createNewAssignment({
        timestamp: time, 
        assignmentId: id, 
        assignmentCreator: creator
      })
    db.collection('assignments').doc(id).set({
      assignmentId: id,
      assignmentName: 'New Assignment',
      createdDate: time,
      lastModifiedDate: time,
      units: [],
      assignmentCreator: creator,
      assignmentType: '',
    })
    this.setState({
      assignmentName: 'New Assignment',
      assignmentType: '',
    })
  }

  saveSettings() {
    const assignmentName = this.state.assignmentName
    const assignmentType = this.state.assignmentType
    this.props.setSavingTrue()
    const timestamp = timestamper()
    this.props.setActiveAssignmentName({assignmentName, timestamp})
    db.collection('assignments').doc(this.props.assignmentId).update({
      assignmentName,
      assignmentType,
      lastModifiedDate: timestamp,
    })
      .then( () => {
        this.props.savingSuccess()
        this.props.setAssignmentType(assignmentType)
      })
      .catch( (error) => this.props.savingError(error) )
  }

  handleAssignmentNameValueChange(e) {
    this.setState({
      assignmentName: e.target.value
    }, () => this.props.setNoChangesFalse())
  }

  selectAssignment(e) {
    if (e.target.value) {
      const assignment = getAssignmentById({
        assignmentList: this.props.assignmentList, 
        assignmentId: e.target.value,
      })
      this.props.setActiveAssignment(assignment)
      let assignmentType = ''
      assignment.assignmentType ? assignmentType = assignment.assignmentType : null
      this.setState({
        assignmentName: assignment.assignmentName, 
        assignmentType, 
      })
    } else {
      this.props.setNullAssignment()
      this.setState({
        assignmentName: '',
        assignmentType: '',
      })
    }
  }

  addAssignmentToUser(assignmentId, userId) {
    this.props.addingAssignmentToUser()
    const batch = db.batch()
    const assignmentRef = db.collection('assignments').doc(assignmentId)
    batch.update(assignmentRef, {['usersAssigned.' + userId ]: true})
    const userRef = db.collection('users').doc(userId)
    batch.update(userRef, {['assignments.' + assignmentId ]: true})
    batch.commit()
      .then( () => this.props.addingAssignmentToUserSuccess(userId) )
      .catch( (error) => this.props.addingAssignmentToUserError(error) )
  }

  /*
  addManager(managerId, groupId) {
    this.props.addingManager()
    const batch = db.batch()
    const userRef = db.collection('users').doc(managerId)
    batch.update(userRef, {['managesGroups.' + groupId]: true})
    const groupRef = db.collection('groups').doc(groupId)
    batch.update(groupRef, {['managers.' + managerId]: true})
    batch.commit()
      .then( () => this.props.addingManagerSuccess(managerId) )
      .catch( (error) => this.props.addingManagerError(error) )
  }

  */

  removeAssignmentFromUser(assignmentId, userId) {
    this.props.removingAssignmentFromUser()
    const batch = db.batch()
    const assignmentRef = db.collection('assignments').doc(assignmentId)
    batch.update(assignmentRef, {['usersAssigned.' + userId ]: false})
    const userRef = db.collection('users').doc(userId)
    batch.update(userRef, {['assignments.' + assignmentId ]: false})
    batch.commit()
      .then( () => this.props.removingAssignmentFromUserSuccess(userId) )
      .catch( (error) => this.props.removingAssignmentFromUserError(error) )
  }

  render() {
    let searchedItems = this.props.items
    const searchType = this.state.searchType
    if (this.state.search && this.props.items) {
      searchedItems = []
      this.props.items.forEach((item) => {
        if (searchType === 'name' || searchType === 'code' || searchType === 'question') {
          if (item[searchType]) {
            if (item[searchType].toLowerCase().search(this.state.search.toLowerCase()) !== -1) {
              searchedItems.push(item)
            }
          }
        } else if (searchType === 'node') {
          if (item.nodeTags && this.state.search) {
            if (item.nodeTags[this.state.search]) {
              searchedItems.push(item)
            }
          }
        }
      })
    }


    return  (
      <AssignmentsManage
        assignmentList={this.props.assignmentList}
        assignmentId={this.props.assignmentId}
        items={searchedItems}
        isFetchingItems={this.props.isFetchingItems}
        isFetchingAssignments={this.props.isFetchingAssignments}
        isSaving={this.props.isSaving}
        noChanges={this.props.noChanges}
        assignment={this.props.assignment}
        error={this.props.error}
        selectedItem={this.props.selectedItem}
        fetchingAssignments={this.props.fetchingAssignments} // action creators direct linked
        fetchingAssignmentsError={this.props.fetchingAssignmentsError}   
        fetchingItems={this.props.fetchingItems}
        fetchingItemsError={this.props.fetchingItemsError}
        selectItem={this.props.selectItem}
        addActiveAssignmentUnit={this.props.addActiveAssignmentUnit}
        addUnitToAssignmentAndSave={this.addUnitToAssignmentAndSave}
        saveSettings={this.saveSettings}
        assignmentNameLocalVal={this.state.assignmentName}
        handleAssignmentNameValueChange={this.handleAssignmentNameValueChange}
        deleteUnitFromAssignmentAndSave={this.deleteUnitFromAssignmentAndSave}
        savedAssignmentNameStore={this.props.assignment ? this.props.assignment.assignmentName : ''}
        selectAssignment={this.selectAssignment}
        createNewAssignment={this.createNewAssignment}
        users={this.props.users}
        isFetchingUsers={this.props.isFetchingUsers}
        isSavingUserAssignment={this.props.isSavingUserAssignment}
        addAssignmentToUser={this.addAssignmentToUser}
        removeAssignmentFromUser={this.removeAssignmentFromUser}
        assignmentType={this.state.assignmentType}
        assignmentTypeStore={this.props.assignmentType}
        handleChange={this.handleChange}
        deleteAssignment={this.deleteAssignment}
        search={this.state.search}
        searchType={this.state.searchType}
        handleSearchChange={this.handleSearchChange}
        nodes={this.props.nodes}
        setActiveAssignmentUnits={this.props.setActiveAssignmentUnits}
        savingSuccess={this.props.savingSuccess}
        savingError={this.props.savingError}
        setSavingTrue={this.props.setSavingTrue}
      />
    )
  }
}

export default connect(
  (state) => ({
    assignmentList: state.assignmentsManage.assignmentList,
    assignmentId: state.assignmentsManage.assignmentId,
    items: state.assignmentsManage.items,
    isFetchingItems: state.assignmentsManage.isFetchingItems,
    isFetchingAssignments: state.assignmentsManage.isFetchingAssignments,
    isSaving: state.assignmentsManage.isSaving,
    noChanges: state.assignmentsManage.noChanges,
    assignment: state.assignmentsManage.assignment,
    error: state.assignmentsManage.error,
    selectedItem: state.assignmentsManage.selectedItem,
    isFetchingUsers: state.assignmentsManage.isFetchingUsers,
    isSavingUserAssignment: state.assignmentsManage.isSavingUserAssignment,
    users: state.assignmentsManage.users,
    assignmentType: state.assignmentsManage.assignmentType,
    nodes: state.assignmentsManage.nodes,
  }),
  (dispatch) => bindActionCreators(assignmentsManageActionCreators, dispatch)
)(AssignmentsManageContainer)





/*
const initialState = {
  assignmentList: null,
  items: null,
  assignmentId: '',
  isFetchingItems: false,
  isFetchingAssignments: false,
  isSaving: false,
  noChanges: false,
  assignment: null,
  error: '',
}


*/


// WEBPACK FOOTER //
// ./src/containers/Assignments/AssignmentsManageContainer.js